import { Resolution } from 'src/domains/calculators/utilities/types';

export const isValidResolution = (
  resolution: Resolution
): boolean => {
  return (
    resolution.width > 0 &&
    resolution.height > 0 &&
    isFinite(resolution.width) &&
    isFinite(resolution.height)
  );
};
